<template>
    <gofix-card fullContent class="mb-0">
        <div class="px-4 py-3">
            <gofix-button label="Add" @click="openModalItem"></gofix-button>
        </div>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @row-click="openModalItem"
            @delete-items="deleteItems"
            ref="gofixTable">
            <template slot="gofix_table:value" slot-scope="row">
                {{ row.item.value > 0 ? `+${row.item.value}` : row.item.value }}
            </template>
            <template slot="gofix_table:rates" slot-scope="row">
                {{ row.item.rates | formatMoney }}
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
            <b-form class="formV2">
                <b-row align-v="center">
                    <b-col md="12">
                        <gofix-form-input-textarea 
                            label="Description"
                            :rows="5"
                            v-model="data.description"
                            content=""></gofix-form-input-textarea>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Unit"
                            vLabel="reference_value_text"
                            v-model="data.unit"
                            :options="modal.unit">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input-number
                            label="Rates"
                            v-model="data.rates"
                            prefix="$" 
                            required />
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
export default {
    name: 'performance_assesment_rates_of_deduction',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig: {
                name: 'performance-assesment-lump-sum-payment',
                controls:{
                    create: false,
                    update: false,
                    delete: true,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tableFilter: false
                },
                filter: {
                    contract_id: {type: "number", value: null, function:"=", with: []},
                    property_type: {type: "text", value: "", function:"ilike", with: []},
                },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width: 50px",
                    },
                    {
                        key: 'id',
                        label: 'Id',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width: 100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width: 400px",
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'unit',
                        label: 'Unit',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width: 200px",
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'rates',
                        label: 'Rates of Deduction',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width: 200px",
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                unit: [
                    // 'per day',
                    // 'half day',
                    // 'per day per person',
                    // 'per occasion',
                ],
            },
            timer: {
                save: null
            },
            data: {
                id: null,
                description: null,
                unit: null,
                rates: null,
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value = this.contract.id
            tableRequest.type_setting = 'pa_rates_of_deduction_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the Rates of Deduction", "danger");
                reject();
            })
        },
        async deleteItems(callback){
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("PerformanceAssesmentSettingsController/deleteItems", {
                ids: ids,
                type: 'pa_rates_of_deduction_setting'
            })
            .then(response => {
                resolve( 'Successfully deleted contract sum' );
            })
            .catch(err =>{
                reject(err);
            });
        },
        async openModalItem(item){

            if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");

            if ( item ) {
                this.modal.title = 'Edit Rates of Deduction'

                this.data.description = item.description
                this.data.unit = item.unit
                this.data.rates = item.rates
                this.data.id = item.id
            } else {
                this.modal.title      = 'Create Rates of Deduction'
                this.data.id          = null
                this.data.description = null
                this.data.unit        = null
                this.data.rates       = null
            }

            this.getReferences();

            this.modal.open = true;
        },
        saveItem() {

            if(!this.data.description) return this.$alertNotification("Desciption is required", "danger")
            if(!this.data.unit) return this.$alertNotification("Unit is required", "danger")
            if(!this.data.rates) return this.$alertNotification("Rates is required", "danger")

            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }

            this.timer.save = setTimeout(() => {
                const request = {
                    id: this.data.id,
                    property_type: this.propertyType,
                    contract_id: this.contract.id,
                    type_setting: 'pa_rates_of_deduction_setting',
                    description: this.data.description,
                    unit: this.data.unit,
                    rates: this.$accounting.unformat(this.data.rates),
                }

                this.modal.loading = true
                
                if ( request.id ) {
                    /* update */
                    this.$store.dispatch(`PerformanceAssesmentSettingsController/updatePASettingsRatesOfDeduction`, request)
                    .then(response => {
                        this.modal.open = false
                        this.modal.loading = false

                        this.data.id = null
                        this.data.description = null
                        this.data.unit = null
                        this.data.rates = null
                        
                        this.$refs.gofixTable.reloadTableItems();
                    })
                    .catch(err => {
                        this.modal.open = false
                        this.modal.loading = false
                        console.log(err)
                    })
                } else {
                    /* add */
                    this.$store.dispatch(`PerformanceAssesmentSettingsController/savePASettingsRatesOfDeduction`, request)
                    .then(response => {
                        this.modal.open = false
                        this.modal.loading = false

                        this.data.id = null
                        this.data.description = null
                        this.data.unit = null
                        this.data.rates = null
                        
                        this.$refs.gofixTable.reloadTableItems();
                    })
                    .catch(err => {
                        this.modal.open = false
                        this.modal.loading = false
                        console.log(err)
                    })
                }
            }, 200)
        },
        getReferences() {
            this.$store.dispatch(`PropertyController/getReferences`, {
                filter: { reference_type: 'Rate Of Deduction Unit' },
                limit: -1,
                isCMS: true
            })
            .then(response => {
                this.modal.unit = [];
                if ( response.data.data.items ) {
                    response.data.data.items.forEach(item => {
                        this.modal.unit.push(item.reference_value_text)
                    });
                }
            })
            .catch(error => {
                reject(error);
            })
        },
    }
}
</script>